import { render, staticRenderFns } from "./MenuFilters.vue?vue&type=template&id=377cedcf"
import script from "./MenuFilters.vue?vue&type=script&lang=js"
export * from "./MenuFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports